import { Navigate, Outlet } from 'react-router-dom'

import { useApp } from '../../../contexts/AppContext'
import { RoleType } from '../../../utils/jwtUtils'

type RoleGuardProps = {
  allowedRoles: RoleType[]
}

const RoleGuard = ({ allowedRoles }: RoleGuardProps) => {
  const { roles } = useApp()

  if (!allowedRoles.some(role => roles.includes(role))) {
    return <Navigate to="/dashboard" replace />
  }

  return <Outlet />
}

export default RoleGuard
